module.exports = __webpack_public_path__ + "static/media/18ECA5.54524f70.jpg";